/* eslint-disable camelcase */
import React from 'react';
import { dateFormat, depositTypeColorMap } from 'enums';
import { typeColor } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var depositsListColumns = [{
  name: 'Номер',
  value: 'id'
}, {
  name: 'Сума',
  render: function render(_ref) {
    var amount = _ref.amount,
        currency = _ref.currency,
        type = _ref.type;
    return ___EmotionJSX("span", {
      css: typeColor(depositTypeColorMap[type])
    }, amount, " ", currency);
  }
}, {
  name: 'Дата',
  value: 'date',
  dateTimeFormat: dateFormat
}];